import React from 'react';
import PropTypes from 'prop-types';
import useCardDrag from '../Drag/useCardDrag';

/**
 * One of your Pokémon in play that can be dragged (usePokemonDrags): it wraps what the spot shows, and a tap still
 * goes to the spot's button.
 */
const DraggablePokemon = ({ enabled, place, lift, settledBy, children }) => {
  const { bind, ghost } = useCardDrag({ enabled, place, lift, settledBy });

  return (
    <>
      <div {...bind}>{children}</div>
      {ghost(children)}
    </>
  );
};

DraggablePokemon.propTypes = {
  enabled: PropTypes.bool.isRequired,
  /** Where it's dragged from (Motion/anchorNames). */
  place: PropTypes.string.isRequired,
  /** Called as the drag starts; returns what's dragged (Drag/dropTargets setDragging). */
  lift: PropTypes.func.isRequired,
  /** What's in the spot, as the game sent it: a new one means the game has answered the drop. */
  settledBy: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default DraggablePokemon;
